import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import DiscoveryTeaser from "@/components/DiscoveryTeaser";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function HomePage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    window.__lenis = lenis;

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="font-sans-body bg-[#FAFAF8] text-[#0F1E3D] antialiased" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <DiscoveryTeaser />
        <Manifesto />
        <Services />
        <Pricing />
        <Booking />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
